import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

/**
 * A small mock of the portal header and a customer-site button in the company's
 * colors, so the owner sees branding changes as they type.
 */
export default function LivePreview({ name, logoUrl, primary, secondary, tagline }) {
  const ok = (c, fallback) => (/^#[0-9a-fA-F]{6}$/.test(c || '') ? c : fallback);
  const p = ok(primary, '#1976d2');
  const s = ok(secondary, '#dc004e');
  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <Box sx={{ bgcolor: p, color: '#fff', px: 2, py: 1.25, display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {logoUrl ? (
          <Box component="img" src={logoUrl} alt="" sx={{ height: 28, maxWidth: 110, objectFit: 'contain', bgcolor: 'rgba(255,255,255,0.9)', borderRadius: 0.5, p: 0.25 }} />
        ) : (
          <Box sx={{ width: 28, height: 28, borderRadius: 0.5, bgcolor: 'rgba(255,255,255,0.3)' }} />
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: 600, flexGrow: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{name || 'Your company'}</Typography>
        <Box sx={{ width: 24, height: 24, borderRadius: '50%', bgcolor: 'rgba(255,255,255,0.35)' }} />
      </Box>
      <Box sx={{ p: 2, bgcolor: '#f5f7fa' }}>
        <Typography variant="caption" color="text.secondary">Customer site</Typography>
        <Typography variant="h6" sx={{ color: p, lineHeight: 1.2 }}>{name || 'Your company'}</Typography>
        <Typography variant="body2" sx={{ mb: 1.5 }}>{tagline || 'Roadside assistance when you need it.'}</Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box sx={{ bgcolor: p, color: '#fff', px: 1.5, py: 0.75, borderRadius: 1, fontSize: 13, fontWeight: 600 }}>Request service</Box>
          <Box sx={{ border: `2px solid ${s}`, color: s, px: 1.5, py: 0.5, borderRadius: 1, fontSize: 13, fontWeight: 600 }}>See plans</Box>
        </Box>
      </Box>
    </Paper>
  );
}
